import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  ROLE,
  SWAL_SETTINGS,
  showFilterlist,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { List, Status, Delete } from "../../services/usermgmt.services";
import * as WalletService from '../../../center/services/wallet.services';
import { useFormik } from "formik";
import { DatePicker, Drawer } from "rsuite";
import CustomError from "../../../../utils/customError";
import * as Yup from "yup";

const UsersTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    // { title: t("sidebar_link_restaurant"), url: "" },
    { title: t("Center Management"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/center-management/center/view/${row._id}`
    );
  };

  const ChangeStatus = (data, Num) => {
    let ids = Array.isArray(data) ? data : [data];
    const formData = new FormData();
    formData.append("o_id", JSON.stringify(ids));
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("admin.cafes.msg_are_you_sure"),
      text: t("Do you really want to change the status."),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("admin.cafes.btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("admin.cafes.btn_yes"),
    }).then((result) => {
      // console.log("result", result);
      if (result.isConfirmed) {
        Status(formData)
          .then((response) => {
            // console.log("kkkk---", response);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };



  function Deletefunction(data, email) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("admin.cafes.msg_are_you_sure"),
      text: t("admin.cafes.you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("admin.cafes.btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("admin.cafes.btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        let ids = Array.isArray(data) ? data : [data];
        // formdata.append("o_id", row._id);
        formdata.append("o_id", JSON.stringify(ids))
        formdata.append("email", email)
        Delete(ids)
          .then((response) => {
            // console.log("🚀 ~ .then ~ response:", response);
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: "Center deleted successfully",
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/center-management/center/${params.pgno}/edit/${row._id}`
    );
  };

  const addFundValidationSchema = Yup.object().shape({
    amount: Yup.number()
      .min(0, "Add fund amount cannot be negative")
      .max(1000000, "Add fund amount must not be more than 1000000")
      .test(
        "max-2-decimals",
        "Add fund amount can have at most 2 decimal places",
        (value) => {
          if (value === undefined || value === null) return true;
          return /^\d+(\.\d{1,2})?$/.test(value.toString());
        }
      )
      .required("Add fund amount is required"),
  });

  const addFundForm = useFormik({
    initialValues: {
      center_name: '',
      center_id: '',
      amount: '',
      reference_number : ''
    },
    validationSchema: addFundValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("wallet_balance", values.amount);
      formData.append("center_id", values.center_id);
      formData.append("reference_number", values.reference_number);

      setAddSubmissionLoader(true);
      WalletService.add(formData, ROLE.SUPER_ADMIN)
        .then((response) => {
          setAddSubmissionLoader(false);
          setShowModal(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeader(false);
            setStatusUpdate(!statsupdate);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error updating profile", error);
        });
      console.log(values);
    },
  });

  const handleClose = () => {
    setShowModal(false);
    addFundForm.resetForm();
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("Center Management")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("admin.filter_placeholder.btn_reset_filter")}
                </button>
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/center-management/center/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th style={{ width: "50px" }}>{t("Logo")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Center ID")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="center_register_id"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Center Name")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="name"
                        />
                      </div>
                    </th>
                    <th>Email</th>
                    <th>Password</th>
                    <th>Address</th>
                    <th className="">{t("admin.cafes.list_heading_phone_number")}</th>
                    {/* <th className="">{t("Doctors")}</th> */}
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("admin.list_heading.list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th className="status_head">{t("admin.list_heading.list_heading_status")}</th>
                    <th className="action_head">{t("admin.list_heading.list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr
                              key={i}
                            >
                              <td>
                                {row?.center_logo ? (
                                  <div className="row_image">
                                    <img
                                      className="rounded"
                                      alt="profile"
                                      src={row?.center_logo}
                                    />
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>{row?.center_register_id}</td>
                              <td>
                                {row?.center_name ? (
                                  <div className="d-flex">
                                    {row?.center_name ? capitalizeFirstLetter(TrimText(row.center_name,30)) : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                              <td>{row?.email ? row.email : "N/A"}</td>
                              <td>{row?.password_to_display ? row.password_to_display : "N/A"}</td>
                              <td>{capitalizeFirstLetter(TrimText(row?.address, 30))}</td>
                              <td>{row?.phone_number ? row.phone_number : "N/A"}</td>
                              {/* <td>30</td> */}

                              <td>
                                {row.createdAt
                                  ? formateDateWithMonth(row.createdAt)
                                  : "N/A"}
                              </td>
                              <td>
                                {row.status === 1 ? (
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      ChangeStatus(row?._id, 0);
                                    }}
                                  >
                                    {t("Unblock")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn ripple btn-secondary"
                                    onClick={() => {
                                      ChangeStatus(row?._id, 1);
                                    }}
                                  >
                                    {t("Block")}
                                  </button>
                                )}
                              </td>

                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      viewfunction(row);
                                    }}
                                  >
                                    {t("admin.button.btn_view")}
                                  </button>

                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => {
                                      goToEdit(row);
                                    }}
                                  >
                                    {t("admin.button.btn_edit")}
                                  </button>
                                  {/* <button
                                    className="btn ripple btn-danger mlAction"
                                    onClick={() => {
                                      Deletefunction(row?._id, row?.email);
                                    }}
                                  >
                                    {t("admin.button.btn_delete")}
                                  </button> */}
                                  {/* <button
                                    className="btn ripple btn-secondary mlAction"
                                    onClick={() => {
                                      // setOpenWithHeader(true)
                                      addFundForm.setFieldValue('center_id', row?._id);
                                      addFundForm.setFieldValue('center_name', row?.center_name);
                                      setShowModal(true);
                                    }}
                                  >
                                    Add Fund
                                  </button> */}

                                  <div className="btn-group mlAction">
                                    <button
                                      type="button"
                                      className="btn btn-dark dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      {t("admin.button.btn_more")}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            navigate(`/admin/center-management/center/service/${row._id}/list/1`)
                                          }}
                                        >
                                          Centre Services
                                        </button>
                                      </li>  
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            navigate(`/admin/center-management/center/educational-video/${row._id}/list/1`)
                                          }}
                                        >
                                          Educational Videos
                                        </button>
                                      </li>  
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            navigate(`/admin/center-management/center/testimonial/${row._id}/list/1`)
                                          }}
                                        >
                                          Testimonials
                                        </button>
                                      </li>  
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            navigate(`/admin/center-management/center/specialization/${row._id}/list/1`)
                                          }}
                                        >
                                          Center Specialization
                                        </button>
                                      </li>  
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            // setOpenWithHeader(true)
                                            addFundForm.setFieldValue('center_id', row?._id);
                                            addFundForm.setFieldValue('center_name', row?.center_name);
                                            setShowModal(true);
                                          }}
                                        >
                                    Add Fund
                                  </button>
                                      </li>  
                                    </ul>
                                  </div>

                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("admin.message.msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Cafes",
                    path: "/admin/center-management/center/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className={`modal fade ${showModal ? 'show' : ''}`} id="modalAddFund" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ display: showModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: '500px', marginTop: '-8%' }}>
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Add Fund</h5>
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="cancel-modal-info gap-4">

                <form onSubmit={addFundForm.handleSubmit}>
                  <div className="row">
                    <div className="col-md-12 mb-4">
                      <label className="form-label">
                        Add Fund <span className="requirestar">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="amount"
                        value={addFundForm?.values?.amount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value) || value === "") {
                            addFundForm.setFieldValue("amount", value);
                          }
                        }}
                        onBlur={addFundForm.handleBlur}
                      />
                      <CustomError name="amount" form={addFundForm} className="text-danger" />
                    </div>
                    <div className="col-md-12 mb-4">
                      <label className="form-label">
                       Reference Number
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="reference_number"
                        value={addFundForm?.values?.reference_number}
                        onChange={addFundForm.handleChange}
                        onBlur={addFundForm.handleBlur}
                      />
                      {/* <CustomError name="amount" form={addFundForm} className="text-danger" /> */}
                    </div>
                  </div>
                  {/* Submit Button */}
                  <div className="button-form">
                    <button type="submit" className={`btn ripple btn-main-primary signbtn w-100 ${addSubmissionLoader ? 'btn-loader' : ''}`}>
                      Add
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal Backdrop */}
      <div className={`modal-backdrop fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }}></div>

    </>
  );
};

export default UsersTable;
